export  default function highlightWord(text, elementId) {
    let element = $('#' + elementId);

    if (!element.length || element.find('.default-item__content .highlight-content').length) {
        return;
    }

    element.find('.default-item__content').html(function (index, html) {
        return html.replace(text, "<span class='highlight-content'>" + text + "</span>");
    });
}


// WEBPACK FOOTER //
// ./src/scripts/highlightWord.js